import React, { useState } from "react";
import PageTitle from "../../components/ui_components/pageTitle";
import Image from "next/image";
import HeroHead from "./HeroHead";
import ScrollToButton from "./scrollToButton";
import Button from "./button";
import { useHeroHooks } from "./HeroHooks";
import { useTranslation } from "next-i18next";
import BrandingHeroIcon from "public/images/branding-hero-icon.png";
import { categoryTranslateKey, subCategoryTranslateKey } from "../../helpers/constants/translate";
import { PlatformOptions } from "../../helpers/filter/filter-options";
import { h1FontSize } from "utils/common";
import StoreSearchPopup from "./StoreSearchPopup";

const Hero = ({ lang, isProduction }) => {
  const {
    router,
    subCategories,
    categories,
    selectedSubCategory,
    selectedCategory,
    filterOptions,
    isSocialMediaActive,
    getSubCategories,
    handleCategoryChange,
    handleSubCategoryChange,
    handleClickDelivery,
    handleClickIcon,
  } = useHeroHooks();
  const { t: heroTranslate } = useTranslation("hero");
  const { t: translate } = useTranslation("categories");

  const [showStoreSearchPopup, setShowStoreSearchPopup] = useState(false);

  const isDisabled = ["categories", ""].includes(selectedCategory);

  const search = async () => {
    if (isDisabled) {
      return;
    }
    await router.push({
      pathname: "/categories/[category]",
      query: {
        category: selectedCategory?.toLocaleLowerCase(),
        extraOptions: JSON.stringify(filterOptions),
      },
    });
  };

  return (
    <>
      <HeroHead isProduction={isProduction}></HeroHead>
      <div className="relative pt-10 mb-20">
        <div className="grid grid-cols-5 px-20">
          <div className="col-span-3 mt-20 mx-20 ">
            <h1 className={`${h1FontSize} text-[#233377] text-left rtl:text-right`}>
              {heroTranslate("MAIN_LEAD_MSG")}
              <span className="text-[#F2C335]">{heroTranslate("MAIN_LEAD_MSG_2")}</span>
            </h1>

            <p className="text-xl my-10 text-justify">{heroTranslate("DESC_LEAD_MSG")}</p>

            <div className="mb-6">
              <div onClick={() => setShowStoreSearchPopup(true)}>
                <Button className=" w-[48%]  text-[#233377] w-border-2  border-[#233377]">
                  {heroTranslate("give_opinion")}
                </Button>
              </div>
            </div>

            <div className="flex gap-2 w-11/12">
              <div className="custom-select flex-[3] mb-[5px] border-4 border-gray-200 rounded-[10px]">
                <select
                  id="countries"
                  className="bg-white border-4 border-gray-100 text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block 
                w-full h-14 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
                dark:focus:border-blue-500 cursor-pointer"
                  onChange={handleCategoryChange}
                  value={selectedCategory}
                  onClick={() => getSubCategories()}
                >
                  <option key="no_category" value="">
                    {heroTranslate("category_default_option")}
                  </option>
                  {categories.map((option: any, index) => (
                    <option value={`${option.attributes.slug}`} key={`category__${index}`}>
                      {translate(categoryTranslateKey(option.attributes.slug))}
                    </option>
                  ))}
                </select>
              </div>
              {subCategories.length != 0 && selectedCategory != "categories" && (
                <div className="custom-select flex-[3] mb-[5px] border-4 border-gray-200 rounded-[10px]">
                  <select
                    id="countries"
                    className="bg-white border-4 border-gray-100 text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block 
                  w-full h-14 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
                  dark:focus:border-blue-500 cursor-pointer"
                    onChange={handleSubCategoryChange}
                    value={selectedSubCategory}
                  >
                    {subCategories.map((option: any, index) => (
                      <option value={option.name} key={`sub_category__${index}`}>
                        {translate(subCategoryTranslateKey(option.name))}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="flex-[2] mb-[5px] border-4 border-gray-200 rounded-[10px]">
                <label htmlFor="livraison">
                  <div className="bg-white border-4 border-gray-100 h-14 flex items-center justify-center rounded-md gap-2 cursor-pointer">
                    <input
                      className="cursor-pointer"
                      type={"checkbox"}
                      id="livraison"
                      onClick={() => handleClickDelivery()}
                    />
                    <label htmlFor="livraison" className="ml-2 cursor-pointer">
                      {heroTranslate("delivery")}
                    </label>
                  </div>
                </label>
              </div>
              <div className="flex-[2] mb-[5px] border-4 border-gray-200 rounded-[10px]">
                <div className="flex bg-white h-14 border-4 border-gray-100 items-center justify-evenly rounded-md gap-2">
                  {PlatformOptions.map((item, index) => (
                    <label
                      key={`platform__${index}`}
                      className={`flex hover:cursor-pointer ${
                        isSocialMediaActive[item.value] ? "p-[3px] bg-yellow rounded-md" : ""
                      }`}
                    >
                      <Image
                        id={item.value}
                        src={item.icon ?? ""}
                        alt={item.icon + "logo"}
                        width={40}
                        height={40}
                        onClick={() => handleClickIcon(item)}
                        style={{
                          maxWidth: "100%",
                          height: "auto",
                        }}
                      />
                    </label>
                  ))}
                </div>
              </div>
              <div className={isDisabled ? "disabled" : ""}>
                <div onClick={search}>
                  <Image
                    className={isDisabled ? "opacity-50" : "cursor-pointer"}
                    src={"/images/search-blue-icon.svg"}
                    alt={"search-blue-icon" + "logo"}
                    width={60}
                    height={60}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="fill col-span-2">
            <Image
              src={BrandingHeroIcon}
              alt={heroTranslate("hero_alt_img")}
              width={500}
              height={500}
              quality={100}
              placeholder="blur"
            />
          </div>
        </div>
        <ScrollToButton
          className={`flex justify-center absolute z-10 w-full bottom-[-7rem]`}
          toId="carousel-categories"
          toRef={null}
          duration={500}
          adjustPosition={-96}
        />
      </div>

      <StoreSearchPopup
        isOpen={showStoreSearchPopup}
        onClose={() => setShowStoreSearchPopup(false)}
        title={heroTranslate("share_experience")}
        placeholder={heroTranslate("search_store")}
      />
    </>
  );
};

export default Hero;
